export const updateRole = (payload: { id: number, name: string }) => ({
    type: "@saga/UPDATE_ROLE",
    payload
});